export default "__VITE_ASSET__DAx6WELM__"